export default {
    id: 'ID',
    title: 'Organisationen',
    name: 'Name',
    parent_organisation_id: 'Übergeordnete Organisation',
    city: 'Stadt',
    type: 'Typ',
    last_active_at: 'Zuletzt aktiv',
    created_at: 'Erstellt am',
    active: 'Aktiv',
    isActive: 'Aktiv',
    isInactive: 'Inaktiv',
    transfer_agreement_accepted_at: 'Weitergabevertrag <br> unterschrieben',
    customFilterTransferAgreement: 'Weitergabevertrag unterschrieben',
    categories: 'Kategorien',
    category: 'Kategorie'
}
